



















































import {
  defineComponent,
  reactive,
  onMounted,
  ref,
} from '@vue/composition-api';
import _ from 'lodash';

import tableOption from '@/table/Customer/list';
import {
  getCustomers,
  deleteCustomer,
} from '@/api/index';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import CommonModalWithPartnerInfo from '@/components/Customer/CommonModalWithPartnerInfo.vue';

const CustomerList = defineComponent({
  components: {
    CommonModalWithPreset,
    CommonModalWithPartnerInfo,
  },
  setup() {
    const refetchQuery = ref(false);
    const partnerInfoModal = ref(null);
    const deleteCustomerModal = ref(null);
    function rowClickHandler(row: any) {
      (partnerInfoModal.value as any).compose(row.item.id, 'CUSTOMER');
    }
    const filter = reactive({
      searchString: '',
    });
    // const computedFilter = computed(() => ({
    //   searchString: filter.searchString !== '' ? `${filter.searchString}` : '',
    // }));

    async function getStats() {
      // detail.name = await getCustomers();
    }

    const refetchQueryHandler = _.debounce(() => {
      refetchQuery.value = true;
    }, 250);

    onMounted(async () => {
      // await getStats();
    });

    function openDeleteCustomerModal(id: number) { (deleteCustomerModal.value as any).compose({ id }); }
    async function deleteCustomerAction(id: number) { await deleteCustomer(id); refetchQuery.value = true; }

    return {
      tableOption,
      getCustomers,
      filter,
      // computedFilter,
      refetchQuery,
      refetchQueryHandler,

      deleteCustomerModal,
      openDeleteCustomerModal,
      deleteCustomerAction,

      partnerInfoModal,
      rowClickHandler,
    };
  },
});

export default CustomerList;
